import { motion } from "framer-motion";

const projects = [
  {
    img: "https://images.pexels.com/photos/35726122/pexels-photo-35726122.jpeg",
    title: "Einfamilienhaus · Zürich",
    meta: "9.8 kWp · Speicher 10 kWh",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    img: "https://images.pexels.com/photos/17965455/pexels-photo-17965455.jpeg",
    title: "Gewerbedach · Aargau",
    meta: "240 kWp · 720 Module",
  },
  {
    img: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1200&auto=format&fit=crop",
    title: "Landwirtschaft · Thurgau",
    meta: "180 kWp · Eigenverbrauchsoptimiert",
  },
  {
    img: "https://images.unsplash.com/photo-1497440001374-f26997328c1b?w=1200&auto=format&fit=crop",
    title: "Mehrfamilienhaus · Bern",
    meta: "32 kWp · ZEV-Lösung",
  },
  {
    img: "https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1200&auto=format&fit=crop",
    title: "Villa · Genf",
    meta: "14 kWp + Wallbox 22 kW",
  },
];

export default function References() {
  return (
    <section
      id="referenzen"
      data-testid="references-section"
      className="relative py-20 md:py-28 bg-[#FAF7EF]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-8">
            <div className="text-sm text-[#EAB308] font-semibold uppercase tracking-widest">
              Referenzen
            </div>
            <h2 className="mt-3 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1D20]">
              Über 850 Anlagen –
              <br className="hidden md:block" />
              <span className="text-[#4B5563]"> ein Auszug.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[200px]">
          {projects.map((p, idx) => (
            <motion.figure
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08 }}
              data-testid={`reference-${idx}`}
              className={`relative rounded-2xl overflow-hidden group img-placeholder ${p.span || ""}`}
            >
              <img
                src={p.img}
                alt={`Realisierte Photovoltaik-Anlage: ${p.title}, ${p.meta}`}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1D20]/85 via-[#1A1D20]/10 to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                <div className="font-display font-semibold text-white text-lg leading-tight">
                  {p.title}
                </div>
                <div className="text-white/75 text-sm mt-1">{p.meta}</div>
              </figcaption>
              <div className="absolute top-4 right-4 px-2.5 py-1 rounded-full bg-[#EAB308] text-[#1A1D20] text-[10px] font-bold uppercase tracking-wider">
                Realisiert
              </div>
            </motion.figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
          <a
            href="#kontakt"
            data-testid="references-cta"
            className="inline-flex items-center justify-center h-12 px-6 rounded-full bg-[#1A1D20] text-white font-semibold text-sm hover:bg-[#2A3B32] transition-colors"
          >
            Referenz in Ihrer Region anfragen
          </a>
          <p className="text-sm text-[#4B5563]">
            Gerne vermitteln wir Ihnen den Kontakt zu einer bestehenden Anlage in
            Ihrer Nähe.
          </p>
        </div>
      </div>
    </section>
  );
}
